import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "hint": "pbui-CKrO2",
  "hint--no-error": "pbui-6kIUW",
  "hint--has-error": "pbui-G2pXE",
  "label": "pbui-Kunxd",
  "container": "pbui-Ut6eR",
  "input__container": "pbui-PM4KV",
  "input__container--disabled": "pbui-9PoPD",
  "input__container--has-error": "pbui-bkbDX",
  "input": "pbui-x7tmo",
  "prefix": "pbui-bEYBP",
  "suffix": "pbui-9cutn",
  "prefix--with-divider": "pbui-AA6VK",
  "suffix--with-divider": "pbui-126C-",
  "input__container--focus-orange": "pbui-c0Lfj"
};
export var InputLabel = function InputLabel(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    _jsx("label", _extends({
      className: styles.label
    }, rest, {
      children: children
    }))
  );
};